//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Appbar from '~/components/core/Appbar.vue';
import Footer from '~/components/core/Footer.vue';

export default {
	components: {
		Appbar,
		Footer,
	},
	props: {
		error: {
			type: Object,
			default: null,
		},
	},
	data: () => ({
		wp_url: process.env.WP_BASE_URL
	}),
	head() {
		return {
			title: '404 - No encontrado',
		};
	},
};
